import axios from "axios";

const LicenseService = {
    async saveLicense(license) {
        const response = axios.post(`/api/license/`, license);
        return response; 
    },
    async deleteLicense(licenseId) {
        const response = axios.post(`api/license/delete/${licenseId}`);
        return response;
    },
    async savePamLicense(license) {
        const response = axios.put('/api/pam/pam-license/upsert', license)
        return response;
    },
    async deletePamLicense(pamSiteLicenseId) {
        const response = axios.delete(`/api/pam/pam-license/delete/${pamSiteLicenseId}`)
        return response;
    },
}

export default LicenseService; 